module.exports = __webpack_public_path__ + "front/img/74.1607dfb5.png";